import { useEffect, useState } from 'react';

/**
 * Returns true if the tab is active/focused in the browser. DIFFERENT from "idle" which is based on the user not interacting with the page.
 * @returns
 */
const useTabIsActive = () => {
	const [isTabVisible, setIsTabVisible] = useState(true);

	useEffect(() => {
		const handleVisibilityChange = () => {
			setIsTabVisible(document.visibilityState === 'visible');
		};

		document.addEventListener('visibilitychange', handleVisibilityChange);
		return () => {
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		};
	}, []);

	return isTabVisible;
};

export default useTabIsActive;
